import { getAsyncRequest } from "@gx1/gx-npm-lib";
import { pushDataLayerNonGartnerUserEvent, pushDataLayerUserLoadedEvent } from "./user-data-layer.module";

export const loadUserState = async () => {
  const handleLoadUserState = async () => {
    const response = await getAsyncRequest("/api/v2/user/state");
    if (response && response.status === 200 && response.data.data) {
      const newUserState = {
        ...response.data.data,
        hasUserState: true,
      };
      pushDataLayerUserLoadedEvent(newUserState);
      pushDataLayerNonGartnerUserEvent(newUserState);
      await window.eventBus.publish("USER_STATE", newUserState);
    } else {
      throw new Error("Failed to load user state");
    }
  };

  const handleLoadUserStateWithErrorCheck = async () => {
    try {
      await handleLoadUserState();
    } catch (err) {
      const newUserState = {
        hasError: true,
      };
      await window.eventBus.publish("USER_STATE", newUserState);
    }
  };

  const handleClearUserState = async () => {
    await window.eventBus.publish("USER_STATE", {});
  };

  await window.eventBus.subscribe("USER_STATE_LOAD", handleLoadUserStateWithErrorCheck);
  await window.eventBus.subscribe("USER_STATE_CLEAR", handleClearUserState);
  try {
    await handleLoadUserState();
  } catch { }
};
